export default "<div id=\"rm_map_div\"></div>"